export default function store(key) {
  const KEY = `cvco.${key}`

  return {
    get() {
      const candidates = [KEY, KEY.split('.').slice(0, -1).join('.')]
      let val
      do {
        val = sessionStorage.getItem(candidates[0])
      } while (candidates.shift() && !val)
      if (!val) return {}
      return JSON.parse(val)
    },

    set(value) {
      if (!value) {
        return
      }
      sessionStorage.setItem(KEY, JSON.stringify(value))
    },
  }
}
